import { makeStyles } from "@material-ui/core/styles";

const expenseModal = (params) => {
  const { containerTop = "50%" } = params;

  return {
    container: {
      fontFamily: "Noto Sans",
      position: "absolute",
      top: containerTop,
      left: "50%",
      transform: "translate(-50%, -50%)",
      outline: 0,
      width: "623px",
      margin: "auto",
      height: "777px",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "0.2em",
      },
      "&::-webkit-scrollbar-track": {
        background: "#d9d9d9",
        borderRadius: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "5px",
      },
      "& .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
        borderBottom: "1px solid rgba(0,0,0, 0.5)",
      },
      "& .MuiInput-root:before": {
        borderBottom: "1px solid #eee",
      },
      "& .MuiInputBase-input": {
        fontSize: "16px",
        paddingBottom: "8px",
        paddingLeft: "8px",
      },
      "& .MuiFormLabel-root": {
        fontSize: "14px",
        paddingLeft: "8px",
      },
      "& .MuiFormLabel-filled, & .MuiInputLabel-shrink": {
        fontSize: "12px",
        paddingLeft: "12px",
      },
      "& .MuiFormControl-root": {
        margin: "0 0 16px 0",
      },
    },
    contentWrapper: {
      minHeight: "450px",
      backgroundColor: "white",
      width: "100%",
      padding: "3%",
      borderRadius: "4px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      margin: "0 0 32px 0",
    },
    dateWrapper: {
      margin: "0 0 24px -15px",
    },
    itemWrapper: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    autoCompleteWrapper: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      margin: "0 0 25px 0",
    },
    autoComplete: {
      width: "48%",
      fontSize: "14px",
      "& .MuiSvgIcon-root": {
        fill: "black",
      },
      "& .MuiInput-root": {
        paddingLeft: "8px",
        paddingBottom: "8px",
      },
    },
    textField: {
      width: "48%",
      margin: "2vh 0",
      borderColor: "#f57c00",
    },
    focused: {
      "& $notchedOutline": {
        borderColor: "yellow",
      },
    },
    headingFour: {
      margin: "0 0 16px 0",
      fontSize: "16px",
      fontWeight: "bold",
    },
    total: {
      margin: "32px 0 16px 0",
      fontSize: "18px",
      fontWeight: "bold",
    },
    headingThree: {
      // margin: '3vh 0',
      fontSize: "20px",
      fontWeight: "bold",
    },
    footerWrapper: {
      display: "flex",
      justifyContent: "end",
      margin: "3vh 0",
    },
    cancel: {
      backgroundColor: "#eee",
      color: "#000",
      marginRight: "2vh",
      // '&:hover': {
      //   backgroundColor: '#e6e6e6',
      // },
    },
    saveClose: {
      borderColor: "#f57c00",
      color: "#f57c00",
      marginRight: "2vh",
      // '&:hover': {
      //   borderColor: '#c7690a',
      // },
    },
    saveContinue: {
      backgroundColor: "#f57c00",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#c7690a",
      },
    },
    customDatePickerCss: {
      width: "49%",
      display: "flex",
      "& .DateInput": {
        width: "85%",
      },
    },

    "@media (max-width:992px)": {
      container: {
        width: "80%",
      },
      autoComplete: {
        width: "100%",
      },
      textField: {
        width: "100%",
      },
      customDatePickerCss: {
        width: "100%",
        "& .DateInput": {
          width: "95%",
        },
      },
    },

    "@media (max-width:655px)": {
      customDatePickerCss: {
        "& .DateInput": {
          width: "93%",
        },
      },
    },

    "@media (max-width:576px)": {
      container: {
        width: "90%",
      },
      footerWrapper: {
        flexWrap: "wrap",
        "& .MuiButton-root": {
          width: "100%",
          margin: "1vh",
        },
      },
    },

    "@media (max-width:410px)": {
      customDatePickerCss: {
        "& .DateInput": {
          width: "90%",
        },
      },
    },
  };
};

export const styles = {
  root: {
    flexGrow: 1,
  },
  picker: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-15px",
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
  grid: (theme) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  }),
  tab: (theme) => ({
    marginLeft: theme.spacing(4),
  }),
};

export const style1 = makeStyles((theme) => ({
  root: styles.root,
  title: styles.title,
  grid: styles.grid(theme),
  tab: styles.tab(theme),
}));

export const style2 = makeStyles((theme) => ({
  root: styles.root,
  title: styles.title,
  grid: styles.grid(theme),
  tab: styles.tab(theme),
  picker: styles.picker,
}));

export const style3 = makeStyles(() => expenseModal({ containerTop: "50%" }));

export const style4 = makeStyles(() => expenseModal({ containerTop: "75%" }));
